<template>
  <div class="highlight-badge" :style="badgeStyle">
    <q-icon v-if="icon" :name="icon" size="18px" />
    <slot>{{ label }}</slot>
  </div>
</template>

<script>
export default {
  name: "HighlightBadge",
  props: {
    color: {
      type: String,
      default: "positive"
    },
    shade: {
      type: String,
      default: "base"
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    }
  },
  computed: {
    badgeStyle() {
      return {
        "--badge-color": `var(--color-${this.color}-${this.shade})`
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/abstracts/colors";

.highlight-badge {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 0.8rem;
  padding: 4px 8px;
  border-radius: 7px;
  font-weight: 600;
  color: color(text);
  background: color-mix(in srgb, var(--badge-color) 60%, #1a1a1a);
  border: 1px solid color-mix(in srgb, var(--badge-color) 80%, #1a1a1a);
}
</style>
